export default function PolicyOverview() {
  const policies = [
    {
      type: 'Auto Insurance',
      policyNumber: 'AUTO-12345',
      premium: '$156.00/month',
      status: 'Active',
      nextPayment: 'Dec 15, 2024',
      icon: 'ri-car-line',
      color: 'bg-blue-500'
    },
    {
      type: 'Home Insurance',
      policyNumber: 'HOME-67890',
      premium: '$89.00/month',
      status: 'Active',
      nextPayment: 'Dec 20, 2024',
      icon: 'ri-home-4-line',
      color: 'bg-green-500'
    },
    {
      type: 'Life Insurance',
      policyNumber: 'LIFE-11223',
      premium: '$45.00/month',
      status: 'Active',
      nextPayment: 'Dec 10, 2024',
      icon: 'ri-heart-pulse-line',
      color: 'bg-purple-500'
    }
  ];

  const recentActivity = [
    { date: 'Nov 28, 2024', action: 'Premium payment processed', amount: '$156.00', type: 'payment' },
    { date: 'Nov 15, 2024', action: 'Policy document updated', amount: '', type: 'document' },
    { date: 'Nov 10, 2024', action: 'Claim submitted for auto policy', amount: '$2,500.00', type: 'claim' },
    { date: 'Oct 28, 2024', action: 'Premium payment processed', amount: '$89.00', type: 'payment' }
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900">Policy Overview</h1>
        <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">
          <i className="ri-add-line mr-2"></i>
          Request Quote
        </button>
      </div>

      {/* Quick Stats */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <div className="flex items-center">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
              <i className="ri-shield-check-line text-2xl text-blue-600"></i>
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">Active Policies</p>
              <p className="text-2xl font-bold text-gray-900">3</p>
            </div>
          </div>
        </div>
        
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <div className="flex items-center">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
              <i className="ri-money-dollar-circle-line text-2xl text-green-600"></i>
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">Monthly Premium</p>
              <p className="text-2xl font-bold text-gray-900">$290</p>
            </div>
          </div>
        </div>
        
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <div className="flex items-center">
            <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center">
              <i className="ri-calendar-check-line text-2xl text-yellow-600"></i>
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">Next Payment</p>
              <p className="text-lg font-bold text-gray-900">Dec 10</p>
            </div>
          </div>
        </div>
        
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <div className="flex items-center">
            <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
              <i className="ri-file-shield-2-line text-2xl text-purple-600"></i>
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">Coverage Amount</p>
              <p className="text-lg font-bold text-gray-900">$485K</p>
            </div>
          </div>
        </div>
      </div>

      {/* Active Policies */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="px-6 py-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900">Your Active Policies</h2>
        </div>
        <div className="p-6">
          <div className="grid gap-4">
            {policies.map((policy, index) => (
              <div key={index} className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer">
                <div className="flex items-center space-x-4">
                  <div className={`w-12 h-12 ${policy.color} rounded-lg flex items-center justify-center`}>
                    <i className={`${policy.icon} text-2xl text-white`}></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">{policy.type}</h3>
                    <p className="text-sm text-gray-500">Policy #{policy.policyNumber}</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="font-semibold text-gray-900">{policy.premium}</p>
                  <p className="text-sm text-gray-500">Next: {policy.nextPayment}</p>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    {policy.status}
                  </span>
                  <i className="ri-arrow-right-s-line text-gray-400"></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Recent Activity */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="px-6 py-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900">Recent Activity</h2>
        </div>
        <div className="p-6">
          <div className="space-y-4">
            {recentActivity.map((activity, index) => (
              <div key={index} className="flex items-center space-x-4 p-3 rounded-lg hover:bg-gray-50 transition-colors">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                  activity.type === 'payment' ? 'bg-green-100' :
                  activity.type === 'document' ? 'bg-blue-100' : 'bg-yellow-100'
                }`}>
                  <i className={`${
                    activity.type === 'payment' ? 'ri-money-dollar-circle-line text-green-600' :
                    activity.type === 'document' ? 'ri-file-text-line text-blue-600' : 'ri-alert-line text-yellow-600'
                  } text-lg`}></i>
                </div>
                <div className="flex-1">
                  <p className="text-sm font-medium text-gray-900">{activity.action}</p>
                  <p className="text-xs text-gray-500">{activity.date}</p>
                </div>
                {activity.amount && (
                  <div className="text-right">
                    <p className="text-sm font-semibold text-gray-900">{activity.amount}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}